import { render } from "./IBoard.vue?vue&type=template&id=2a18ab24"
import script from "./IBoard.vue?vue&type=script&lang=js"
export * from "./IBoard.vue?vue&type=script&lang=js"

import "./IBoard.vue?vue&type=style&index=0&id=2a18ab24&lang=scss"
script.render = render

export default script